import React from 'react';
import PropTypes from 'prop-types';
import classes from './Preview.module.css';

export default function Desktop(props) {
  const { url, height } = props;
  const classess = [
    classes.mwb_gallery_template_view,
    height === 0 ? classes.fixedHeight : '',
  ];

  const frameCSS = [
    classes.desktop_iframe,
    height === 0 ? classes.fixedHeightIframe : '',
  ];

  return (
    <div className={classess.join(' ')}>
      <iframe
        title="test"
        className={frameCSS.join(' ')}
        src={url}
        width="100%"
        height="100%"
      />
    </div>
  );
}

Desktop.propTypes = {
  url: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
